import { Component, OnInit, ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { ApiEnvironmentBannerService } from 'src/app/services/api-environment-banner.service';
import { UserRole } from 'src/app/shared/models/users/user-role';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-external-navbar',
  templateUrl: './external-navbar.component.html',
  styleUrls: ['./external-navbar.component.scss']
})
export class ExternalNavbarComponent implements OnInit {

  appVersionNavigationBar = "";
  environmentBanner: string | null = null;
  isProductionBanner = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private apiEnvironmentBanner: ApiEnvironmentBannerService,
    public settingsService: SettingsService
  ) {

  }

  async ngOnInit() {
    if (environment.production == false)
    {
      this.appVersionNavigationBar = environment.appVersion;
    }
    this.apiEnvironmentBanner.getBannerLabel().subscribe((label) => {
      this.environmentBanner = label;
      this.isProductionBanner = this.apiEnvironmentBanner.isProductionBanner(label);
    });
    console.log("External Nav");
  }

  ngDoCheck() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url === "/settings" || e.url === "/broker-account") {
          //this.showTextInHeader = true;
          //this.headerText = e.url === "/settings" ? "Settings" : "Manage Broker Users";
        } else {
          //this.showTextInHeader = false;
        }
      }
    })
  }

}

